import React from "react";

export default function Logo(): React.ReactElement {
  return (
    <div style={{ padding: "0 20px" }}>
      <a href="https://onedmg.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="./images/logo_static.png"
          alt="DataMesh Group"
          style={{ width: "180px" }}
        />
      </a>
    </div>
  );
}
